import { WbmApiClient } from "@wbmason/api-client";
import { WbmApiClient as LegacyWbmApiClient } from "wbm-api-client";
import { ENABLE_LEGACY_ACCESS_TOKEN } from "../../consts";
import EnvironmentService from "./environmentService";

let _getToken: (() => string) | undefined;

export function setGetToken(getToken: () => string) {
  if (typeof window !== "undefined") {
    if (
      !window.process ||
      !window.process.env ||
      !window.process.env.ACCESS_TOKEN
    ) {
      window.process = {
        env: {
          ACCESS_TOKEN: getToken(),
          APIM_BASE_URL: EnvironmentService.get().apimUrl,
        } as any,
      } as any;
    }
  }
  _getToken = getToken;
}

let _client: LegacyWbmApiClient;

let _newClient: WbmApiClient;

export function lazyClient() {
  if (ENABLE_LEGACY_ACCESS_TOKEN() === false) {
    if (_newClient) {
      return _newClient;
    }

    const options = WbmApiClient.defaultOptions();

    _newClient = new WbmApiClient(options);

    return _newClient;
  } else {
    if (_client) {
      return _client;
    }

    const options = LegacyWbmApiClient.defaultOptions();

    if (EnvironmentService.get().isEcom) {
      options.token = {
        authRedirectUrl: undefined,
        get: function () {
          return (window["digitalData" as any] as any)?.microServiceInfo
            ?.Gateway?.token as string;
        },
        refresh: undefined,
      };
    } else {
      if (options.token && _getToken) {
        options.token.get = _getToken;
        options.token.authRedirectUrl = undefined;
        options.token.refresh = undefined;
      }
    }

    _client = new LegacyWbmApiClient(options);

    return _client;
  }
}
